webpackJsonp([263791100135453],{

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/meadow.cb4f68ee.png";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _fontawesomeFreeSolid = __webpack_require__(13);
	
	var _meadow = __webpack_require__(479);
	
	var _meadow2 = _interopRequireDefault(_meadow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
		return _react2.default.createElement(
			'div',
			{ className: 'about' },
			_react2.default.createElement(_banner2.default, { type: 'about', title: 'About Us' }),
			_react2.default.createElement(
				'section',
				{ className: 'page-grid' },
				_react2.default.createElement(
					'section',
					{ className: 'page-grid-section' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'text-center intro-div' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Ofsted Registered Childminder' }),
							_react2.default.createElement(
								'div',
								{ className: 'rc-copy regular margin-bottom' },
								'Rated as \'Good\''
							),
							_react2.default.createElement(
								'div',
								{ className: 'rc-copy small' },
								'I am an Ofsted registered childminder based in the heart of Oxford. I provide excellent quality training in a safe and  friendly environment. I have many years experience in childminding with excellent references.',
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								'I live in an area overlooking a meadow with a great walking route and nature walks which are a great source of education and discovery for children.',
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								'Current paediatric first aid certificate; Generalist safeguarding; Specialist safeguarding;',
								_react2.default.createElement('br', null),
								'EYFS stage 1.'
							)
						)
					)
				)
			),
			_react2.default.createElement(
				'section',
				{ className: 'page-grid grey key-info' },
				_react2.default.createElement(
					'section',
					{ className: 'page-grid-section' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-4' },
								_react2.default.createElement(_sectionTitle2.default, { title: 'Availability', color: 'black' }),
								_react2.default.createElement(
									'div',
									{ className: 'rc-copy small' },
									'Feel free to contact me to discuss further details of availability.'
								),
								_react2.default.createElement('br', null),
								_react2.default.createElement(_button2.default, { text: 'Contact Now', link: '/contact-us/', action: 'true' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-4' },
								_react2.default.createElement(_sectionTitle2.default, { title: 'Working Hours', color: 'black' }),
								_react2.default.createElement(
									'div',
									{ className: 'opening-times' },
									'8 AM - 5:30 PM'
								),
								_react2.default.createElement(
									'div',
									{ className: 'rc-copy small' },
									'We would be happy to discuss more flexible timings if required.'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-4' },
								_react2.default.createElement(_sectionTitle2.default, { title: 'Age Ranges', color: 'black' }),
								_react2.default.createElement(
									'div',
									{ className: 'price-tag' },
									_react2.default.createElement(
										'span',
										null,
										'0 - 5'
									),
									' ',
									_react2.default.createElement(
										'small',
										null,
										'years'
									)
								)
							)
						)
					)
				)
			),
			_react2.default.createElement(
				'section',
				{ className: 'page-grid about-blocks-div' },
				_react2.default.createElement(
					'section',
					{ className: 'page-grid-section' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-lg-6' },
								_react2.default.createElement('img', { src: _meadow2.default })
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-lg-6' },
								_react2.default.createElement(
									'div',
									{ className: 'about-blocks' },
									_react2.default.createElement(_sectionTitle2.default, { title: 'When is childcare available?', color: 'black' }),
									_react2.default.createElement(
										'div',
										{ className: 'rc-copy small' },
										'All Year, Christmas holidays, Emergency Cover, Half-term holidays, Negotiable, Spring holiday, Summer holiday'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'about-blocks' },
									_react2.default.createElement(_sectionTitle2.default, { title: 'Facilities', color: 'black' }),
									_react2.default.createElement(
										'div',
										{ className: 'rc-copy small' },
										'Arts and crafts, Computer, Cooking, Dressing up, Educational Toys, Large Garden, Messy Play Area, Quiet room / area, Sleeping Area, Visit & Outings'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'about-blocks' },
									_react2.default.createElement(_sectionTitle2.default, { title: 'Pickups', color: 'black' }),
									_react2.default.createElement(
										'div',
										{ className: 'rc-copy small' },
										_react2.default.createElement(
											'p',
											null,
											'Offers pickups: Yes'
										),
										_react2.default.createElement(
											'p',
											null,
											'Details: Local schools,nurseries and pre-schools'
										)
									)
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-21c00dac2b2b56290f89.js